import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from "reactstrap/es/Button"
import { Popover } from 'antd'
import DeleteLabelModal from "./DeleteLabelModal"
import { getTooltipContent, getModalContent } from '../shared/BulkActionTooltipModalUtils'

class DeleteSelectItem extends Component {
    state = {
        isOpen: false,
        showModal: false,
        modalType: null
    }

    _handleToggleModal = () => {
        const { resetBulkAll, selectedItems, closeMenu } = this.props
        const r = window.confirm(`Are you sure want to delete label for ${selectedItems.length} ${selectedItems.length > 1 ? 'orders' : 'order'} selected?`)

        if (r !== true) {
            resetBulkAll()
            closeMenu()
            return
        }

        const { isOpen } = this.state

        this.setState({
            isOpen: !isOpen
        })
    }

    _closePopup = () => {
        const { closeMenu } = this.props
        this.setState({
            isOpen: false
        })
        closeMenu()
    }

    _openModal = (modalType) => {
        this.setState({ modalType, showModal: true })
    }

    _closeModal = () => {
        this.setState({ showModal: false })
    }

    render() {
        const { isOpen, showModal, modalType } = this.state
        const { items = [], selectedItems = [] } = { ...this.props }
        const listItems = items.filter(item => selectedItems.includes(item._id))
        // Each disabled item is counted under exactly one reason (has new label takes priority over status)
        // so the tooltip/modal counts stay accurate.
        const listItemsHasLabel = listItems.filter(itemH => itemH.meta && itemH.meta.label)
        const listItemsDisable = listItems.filter(itemH => ['labelled', 'packaged', 'cancelled', 'cancel-ship'].includes(itemH.production_status) && !(itemH.meta && itemH.meta.label))
        const disabledBtn = listItemsDisable.length > 0 || listItemsHasLabel.length > 0

        return (
            <div className="DeleteSelectItem">
                <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', width: '100%' }}>
                    <Button color="link" onClick={this._handleToggleModal} disabled={disabledBtn}>Delete label</Button>
                    {disabledBtn && (
                        <Popover content={getTooltipContent(listItemsHasLabel, listItemsDisable, this._openModal)} title="Lý do không thể Delete label" trigger="hover">
                            <i className='icon-info3 cursor-pointer text-info' style={{ position: 'absolute', right: '10px', top: 'calc(50% - 8px)' }} />
                        </Popover>
                    )}
                </div>
                {isOpen && (
                    <DeleteLabelModal
                        {...this.props}
                        isOpen={isOpen}
                        handleToggleModal={this._closePopup}
                    />
                )}
                {getModalContent(modalType, showModal, listItemsHasLabel, listItemsDisable, this._closeModal)}
            </div>
        )
    }
}

DeleteSelectItem.propTypes = {
    selectedItems: PropTypes.array.isRequired
}

export default DeleteSelectItem